import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

import type { LoadNetworkBrandThemeProps } from '../components/LoadNetworkBrandTheme/LoadNetworkBrandTheme';

const loader = () =>
  import(/* webpackChunkName: "4-feat-network-brand-theme-integration" */ './LoadNetworkBrandThemeIntegration').then(
    ({ LoadNetworkBrandThemeIntegration }) => ({
      default: LoadNetworkBrandThemeIntegration,
    })
  );

export const LoadableNetworkBrandTheme: ReturnType<typeof lazyLoadOnRender<LoadNetworkBrandThemeProps>> =
  lazyLoadOnRender<LoadNetworkBrandThemeProps>({ loader });
